const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Resolve an image reference that can be:
 *  - null / undefined
 *  - a legacy data URL  (data:image/...)
 *  - an absolute URL    (http:// or https://)
 *  - a backend-relative path (/api/files/qrise/backgrounds/xxx.jpg)
 */
export function resolveImageUrl(value) {
  if (!value) return null;
  if (value.startsWith("data:")) return value;
  if (/^https?:\/\//i.test(value)) return value;
  if (value.startsWith("/")) return `${BACKEND_URL}${value}`;
  return value;
}
